<template>
  <div class="modal-content" style="max-width: 95vw;">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ isEdit ? 'Izmeni' : 'Dodaj novi' }} Kasko
      </h5>
    </div>
    <div class="modal-body">
      <div v-if="isEdit" class="alert alert-warning py-2 mb-3">
        <strong>Napomena:</strong> Sve vrednosti u tabeli, koje su dobijene od Osiguravajuće kuće, obavezno uvećati za 5%
      </div>
      <div v-if="loading" class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else>
        <!-- Basic Info -->
        <div class="row mb-3">
          <div class="col-md-3">
            <label class="form-label">Važi od <span class="text-danger">*</span></label>
            <input
              type="date"
              class="form-control"
              v-model="formData.valid_from"
              :disabled="isEdit"
              required
            />
          </div>
          <div class="col-md-3">
            <label class="form-label">Aktivno</label>
            <div class="form-check mt-2">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="formData.active"
              />
            </div>
          </div>
        </div>

        <!-- Kasko Table -->
        <div class="table-responsive">
          <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
            <thead class="table-light">
              <tr>
                <th style="width: 25%;">Neto cena kola</th>
                <th style="width: 25%;">Najam kola na 12 meseci (%)</th>
                <th style="width: 25%;">12-36 meseci (%)</th>
                <th style="width: 25%;">48+ (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="range in cenaRanges" :key="range">
                <td><strong>{{ range }}</strong></td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control form-control-sm"
                    v-model.number="formData[range].najam_12_meseci"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control form-control-sm"
                    v-model.number="formData[range].meseci_12_36"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control form-control-sm"
                    v-model.number="formData[range].meseci_48_plus"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="cancel">
        Odustani
      </button>
      <button type="button" class="btn btn-primary" @click="saveData">
        Sačuvaj
      </button>
    </div>
  </div>
</template>

<script>
import KaskoDataService from "../../services/kasko.service";

export default {
  name: "kasko-form",
  props: ["data"],
  data() {
    const emptyRange = () => ({ najam_12_meseci: null, meseci_12_36: null, meseci_48_plus: null });
    
    return {
      loading: false,
      cenaRanges: [
        "do 25000",
        "do 50000",
        "preko 50000",
      ],
      formData: {
        valid_from: "",
        active: true,
        "do 25000": emptyRange(),
        "do 50000": emptyRange(),
        "preko 50000": emptyRange(),
      },
    };
  },
  computed: {
    isEdit() {
      return this.data && this.data.valid_from;
    },
  },
  mounted() {
    if (this.isEdit) {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.formData.valid_from = this.data.valid_from;
      
      try {
        const response = await KaskoDataService.getByValidFrom(this.data.valid_from);
        const records = response.data;
        
        records.forEach((record) => {
          if (this.formData[record.cena_range]) {
            this.formData[record.cena_range] = {
              najam_12_meseci: record.najam_12_meseci,
              meseci_12_36: record.meseci_12_36,
              meseci_48_plus: record.meseci_48_plus,
            };
          }
          this.formData.active = record.active;
        });
        
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: "Error loading Kasko data",
        });
        this.loading = false;
      }
    },
    async saveData() {
      if (!this.formData.valid_from) {
        this.$store.commit("app/showAlert", {
          type: "warning",
          message: "Molimo popunite obavezno polje (Važi od)",
        });
        return;
      }

      if (this.isEdit) {
        await this.update();
      } else {
        await this.create();
      }
    },
    cancel() {
      this.$store.commit("app/hideModal");
    },
    async update() {
      try {
        const dataToSend = {};
        this.cenaRanges.forEach(range => {
          dataToSend[range] = this.formData[range];
        });
        dataToSend.active = this.formData.active;
        
        await KaskoDataService.update(this.formData.valid_from, dataToSend);
        
        this.$store.commit("app/showAlert", {
          type: "success",
          message: "Kasko je promenjen!",
        });
        this.$store.commit("app/hideModal");
      } catch (e) {
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: e.response?.data?.message || e.message,
        });
      }
    },
    async create() {
      try {
        const dataToSend = {
          valid_from: this.formData.valid_from,
          active: this.formData.active,
        };
        
        this.cenaRanges.forEach(range => {
          dataToSend[range] = this.formData[range];
        });
        
        await KaskoDataService.create(dataToSend);
        
        this.$store.commit("app/showAlert", {
          type: "success",
          message: "Kasko je kreiran!",
        });
        this.$store.commit("app/hideModal");
      } catch (e) {
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: e.response?.data?.message || e.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.table {
  font-size: 0.875rem;
  margin-bottom: 0;
}
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  padding: 0.5rem 0.25rem;
  white-space: nowrap;
}
.table td {
  vertical-align: middle;
  padding: 0.4rem 0.25rem;
}
.form-control-sm {
  font-size: 0.875rem;
  padding: 0.3rem 0.4rem;
  width: 100%;
}
.modal-body {
  padding: 1rem 1.5rem;
}
.table-responsive {
  overflow-x: auto;
  overflow-y: visible;
}
.row.mb-3 {
  margin-bottom: 1rem !important;
}
</style>
